import { toast } from "react-toastify";

const parseResponse = async (response) => {
  const contentType = response.headers.get("content-type") || "";

  if (contentType.includes("application/json")) {
    return response.json();
  }

  const text = await response.text();
  return text ? { message: text } : {};
};

export const handleRegister = async (formData) => {
  try {
    const response = await fetch("/api/register", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });

    const data = await parseResponse(response);

    if (response.ok) {
      toast.success("Registered Successfully");
      return data;
    } else {
      toast.error(data?.message || "Registration Failed");
      return data;
    }
  } catch (error) {
    toast.error("Backend server is not reachable");
    return { status: "error", message: "Backend server is not reachable" };
  }
};
export const handleLogin = async (email, password) => {
  try {
    const response = await fetch("/api/login", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email: email?.trim(), password }),
    });
    const data = await parseResponse(response);
    return data;

  } catch (error) {
    toast.error("Backend server is not reachable");
    return { status: "error", message: "Backend server is not reachable" };
  }
};

export const requestPasswordResetOtp = async (email) => {
  try {
    const response = await fetch("/api/forgot-password/request-otp", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email }),
    });

    return await parseResponse(response);
  } catch (error) {
    toast.error("Backend server is not reachable");
    return { status: "error", message: "Backend server is not reachable" };
  }
};

export const resetPasswordWithOtp = async ({ email, otp, newPassword }) => {
  try {
    const response = await fetch("/api/forgot-password/reset", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Tenant-ID": JSON.parse(localStorage.getItem('user') || '{}')?.tenantEmail || "PENSENSE_DEFAULT"
      },
      body: JSON.stringify({ email, otp, newPassword }),
    });

    return await parseResponse(response);
  } catch (error) {
    toast.error("Backend server is not reachable");
    return { status: "error", message: "Backend server is not reachable" };
  }
};
